export default __webpack_public_path__ + "static/media/crystler.ab5c0287.jpg";